module.exports = {
  defaultLocale: 'en',
  prerender: true,
  // googleMapsAPIKey: 'AIzaSyAvDgVyepNN0IHc78s2TGj_OdLZbL2WLQ4', // set up billing
  googleMapsAPIKey: 'AIzaSyBjffVYE4214dRYSEzO3bKSnqP3YAg8rZw', // test
};



// WEBPACK FOOTER //
// ./src/config/app.conf.js